import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography } from "@material-ui/core";
import TableGeneric from "../../compartidos/abms/TableGeneric";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import { getHistorialTurnosAfiliado } from "../../../actions/webAfiliado/afiliadoTurnosAction";
import { useDispatch, useSelector } from "react-redux";
import { getCredenciales } from "../../../actions/webAfiliado/afiliadoVariosAction";
import moment from "moment";
import { capitalize } from "../../../helpers/randoms";
import { ESTADISTICAS_OSPEDYC, TIPO_TURNO } from "../../../utils/constants";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold",
        marginBottom:"1rem"
    },
    name:{
        fontWeight:"bold"
    },
    fecha:{
        fontWeight:"bold"
    }
}));

const HistorialAtencion = (props) => {

    const classes = useStyles();
    const dispatch=useDispatch()
    const { credenciales } = useSelector(state => state.afiliadoVarios)
    const { historialAtencion } = useSelector(state => state.afiliadoTurnos)

    useEffect(() => {
        dispatch(getCredenciales())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (credenciales !== null) {
            dispatch(getHistorialTurnosAfiliado(credenciales))
        }
        // eslint-disable-next-line
    }, [credenciales])

    useEffect(() => {
        dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.TURNOS))
        // eslint-disable-next-line
    }, [])

    if (credenciales === null) {
        return <LoadingBeforeViewData />
    }
    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>Historial de atención</Typography>
                <TableGeneric
                    data={historialAtencion}
                    columns={[
                        {
                            id:"fecha",
                            label:"Fecha y hora",
                            sort:true,
                            customBody: (item) => <Typography color="primary" className={classes.fecha}>{`${capitalize(moment(item.fecha).format("dddd DD"))} de ${moment(item.fecha).format("MMMM")}\n${item.hora}hs`}</Typography>,
                        },
                        {
                            id:"idAfiliado",
                            label:"Nombre y apellido",
                            customBody: (item) => <Typography className={classes.name}>{credenciales.find(e=>e.idAfiliado===item.idAfiliado)?.apellidoYNombre}</Typography>,
                        },
                        {
                            id:"efectorRed.nombreEfector",
                            label:"Profesional",
                            customBody: (item) => <Typography >{item.efectorRed.nombreEfector}</Typography>,
                        },
                        {
                            id:"especialidad.descripcionEspecialidades",
                            label:"Especialidad",
                            customBody: (item) => <Typography color="primary">{item.especialidad.descripcionEspecialidades}</Typography>,
                        },
                        {
                            id:"centroMedico.descripcionCentro",
                            label:"Centro médico",
                            customBody: (item) => <Typography >{item.centroMedico.descripcionCentro}</Typography>,
                        },
                        {
                            id:"idTipoTurnosSol",
                            label:"Tipo",
                            customBody: (item) => <Typography>{item.idTipoTurnoSol === TIPO_TURNO.PRESENCIAL ? "Presencial" : "Virtual"}</Typography>,
                        }
                    ]}
                />
            </Container>
        </div>
    );
};

export default HistorialAtencion
